import React from "react";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { HelmetProvider } from "react-helmet-async";
import { ClickOutsideProvider } from "react-native-click-outside";
import ToastManager from "./toasts/ToastManager";
import { GrowthBookProvider } from "@growthbook/growthbook-react";

import { gb } from "./services/growthbook/init";

type Props = {
  children: React.ReactNode;
};

const Providers: React.FC<Props> = ({ children }) => {
  return (
    <SafeAreaProvider>
      <GrowthBookProvider growthbook={gb}>
        <HelmetProvider>
          <ToastManager>
            <ClickOutsideProvider>{children}</ClickOutsideProvider>
          </ToastManager>
        </HelmetProvider>
      </GrowthBookProvider>
    </SafeAreaProvider>
  );
};

export default Providers;
